export default __webpack_public_path__ + "static/media/resume.73559b79.svg";